<template>
  <div>
    <el-dialog
      :destroy-on-close="true"
      :visible.sync="isFindUnt"
      width="800px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">
        <span>添加团队信息</span>
      </div>
      <div class="dialog-form" st>
        <div class="user-table">
          <el-table
            :data="tableData"
            style="width: 100%"
            header-row-class-name="table-header"
            header-cell-class-name="table-header-cell"
            :stripe="true"
            :border="true"
          >
            <el-table-column prop="unitName" label="团队名称" align="center">
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template #default="{ row }">
                <span v-if="row.applicationStatus == 1">审核中</span>
                <span v-if="row.applicationStatus == 2">正常关联</span>
                <span v-if="row.applicationStatus == 3">已拒绝</span>
                <span v-if="row.applicationStatus == 4">已解除</span>
                <span v-if="row.applicationStatus == 5">已删除</span>
              </template>
            </el-table-column>

            <div slot="empty" style="text-align: left">
              <el-empty description="暂无数据" :image-size="100" />
            </div>
          </el-table>
        </div>

        <div class="dialog-btns" style="margin-top: 20px">
          <el-button class="cancel" @click="isFindUnt = false">关闭</el-button>
          <el-button class="confirm" @click="isRz">去认证</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :destroy-on-close="true"
      :visible.sync="emilVisible"
      width="700px"
      :close-on-click-modal="false"
      @closed="closeEmil"
    >
      <div slot="title" class="dialog-title">
        <span>申请加入团队</span>
      </div>
      <div class="dialog-form">
        <el-form
          :model="emilData"
          ref="elfrom"
          :rules="emilRules"
          label-position="left"
          label-width="100px"
        >
          <el-form-item prop="name" label="姓名">
            <el-input
              :disabled="customerInfoDTO.name ? true : false"
              v-model="emilData.name"
              placeholder="请输入您的真实姓名"
            ></el-input>
          </el-form-item>
          <div
            class="bottomtip"
            :style="{ display: customerInfoDTO.name ? 'none' : 'black' }"
          >
            <div>
              为了确保您的申请尽快通过审核，请输入您的真实姓名，切勿输入“x先生”、“x老师”，信息一经提交，无法修改！
            </div>
          </div>
          <el-form-item prop="emil" label="邮箱">
            <el-input
              :disabled="userInfo && userInfo.mail ? true : false"
              v-model="emilData.emil"
              placeholder="请输入申请人邮箱"
            ></el-input>
          </el-form-item>

          <el-form-item
            prop="code"
            label="图片验证码"
            v-show="userInfo && !userInfo.mail"
          >
            <div style="display: flex; width: 100%">
              <el-input
                v-model="emilData.code"
                placeholder="请输入图片验证码"
              ></el-input>
              <div class="verify-img">
                <img @click="getImgCode" :src="emilData.codeImg" alt="" />
              </div>
            </div>
          </el-form-item>

          <el-form-item
            prop="elCode"
            label="邮箱验证码"
            v-show="userInfo && !userInfo.mail"
          >
            <div style="display: flex; width: 100%">
              <el-input
                v-model="emilData.elCode"
                placeholder="请输入验证码"
              ></el-input>
              <div
                v-loading="isloading"
                @click="getEmilCode"
                class="verify-img"
                style="text-align: center; line-height: 40px; color: white"
              >
                <span v-if="!sendMsgDisabled2">获取验证码</span>
                <span v-if="sendMsgDisabled2">{{
                  codeTime2 + "秒后获取"
                }}</span>
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="uniName" label="单位名称">
            <!-- <el-input
              v-model="emilData.phone"
              placeholder="请输入单位名称"
            ></el-input> -->
            <el-select
              @focus="clear"
              @hook:mounted="clear"
              @visible-change="clear"
              @change="uniNameChange"
              style="width: 100%"
              v-model="emilData.uniName"
              filterable
              remote
              reserve-keyword
              placeholder="请输入您申请加入的单位名称"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.unitName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="pi" label="“PI/课题组">
            <el-select
              @focus="clear"
              @hook:mounted="clear"
              @visible-change="clear"
              filterable
              @change="updata"
              style="width: 100%"
              v-model="emilData.pi"
              placeholder="请选择您申请加入的PI团队"
            >
              <el-option
                v-for="item in pioptions"
                :key="item.id"
                :label="item.customerName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div class="bottomtip">
            <div>如您申请加入的PI不在列表，请联系在线客服。</div>
          </div>
          <div class="dialog-btns">
            <el-button class="cancel" @click="emilVisible = false"
              >取消</el-button
            >
            <el-button class="confirm" @click="subSetEmil">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import userApi from "../../../api/user.js";
export default {
  name: "emdialog",
  props: ["customerInfoDTO", "typee"],

  data() {
    Array.from(document.getElementsByClassName("el-select")).forEach(item => {
      item.children[0].children[0].removeAttribute("readOnly");
      item.children[0].children[0].onblur = function() {
        let _this = this;
        setTimeout(() => {
          _this.removeAttribute("readOnly");
        }, 200);
      };
    });

    const reg = /^[\u4e00-\u9fa5]$/;
    var validatePass = (rule, value, callback) => {
      let len = 0;
      for (let i = 0; i < value.length; i++) {
        let word = value.charAt(i); //获取指定位置的字符
        if (!reg.test(word)) {
          //再用正则判断这个字符是否是中文
          //非中文单字节加1
          len++;
        } else {
          //中文单字节加5
          len++;
          // len += 5
        }
      }
      if ((len < 1 && len > 0) || len > 5) {
        callback(new Error("姓名长度为1-5个汉字"));
      } else {
        callback();
      }
    };

    var checkEmail = (rule, value, callback) => {
      const mailReg = /@.*\./;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
    return {
      tableData: [],
      isFindUnt: false,
      namejson: "",
      codeInterval3: null,
      pioptions: [],
      options: [],
      value: [],
      list: [],
      loading: false,
      isloading: false,
      codeTime2: 59, //邮箱 发送验证码倒计时
      sendMsgDisabled2: false, //邮箱 是否显示获取验证码按钮
      emilVisible: false,
      emilRules: {
        code: [
          {
            required: false,
            trigger: ["change", "blur"],
            message: "请输入图片验证码"
          }
        ],
        elCode: [
          {
            required: false,
            trigger: ["change", "blur"],
            message: "请输入验证码"
          }
        ],
        emil: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入申请人邮箱"
          },
          { validator: checkEmail, trigger: ["change", "blur"] }
        ],
        name: [
          {
            required: true,
            message: "请输入您的真实姓名"
          },
          { validator: validatePass }
        ],
        uniName: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入您申请加入的单位名称"
          }
        ],
        pi: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请选择您申请加入的PI团队"
          }
        ]
      },
      emilData: {
        code: "",
        name: "",
        elCode: "",
        emil: "",
        codeImg: "",
        codeKey: "",
        uniName: "",
        pi: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user/userInfo"
    })
  },

  methods: {
    clear(async) {
      Array.from(document.getElementsByClassName("el-select")).forEach(item => {
        item.children[0].children[0].removeAttribute("readOnly");
        item.children[0].children[0].onblur = function() {
          let _this = this;
          setTimeout(() => {
            _this.removeAttribute("readOnly");
          }, 200);
        };
      });
    },
    updata() {
      // this.$forceUpdate();
    },
    getImgCode() {
      userApi.imgcod({ channel: "pc" }).then(res => {
        this.emilData.codeImg = res.data.base64Image;
        this.emilData.codeKey = res.data.codeKey;
      });
    },

    uniNameChange(e) {
      console.log(e, "--e---");
      if (this.emilData.pi) {
        this.emilData.pi = "";
      }
      this.getpiList();
    },
    visibleChange(type) {
      if (
        type &&
        this.emilData.uniName &&
        this.namejson != this.emilData.uniName
      ) {
        this.namejson = JSON.parse(JSON.stringify(this.emilData.uniName));

        this.getpiList();
      }
    },
    getpiList() {
      let params = {
        channel: "pc",
        unitName: this.options.filter(res => {
          return res.id == this.emilData.uniName;
        })[0].unitName
      };
      userApi.piList(params).then(res => {
        if (res.code == 200) {
          this.pioptions = res.data;
        }
      });
    },
    remoteMethod(query) {
      if (query.length > 1) {
        this.options = [];
        this.loading = true;
        let params = {
          channel: "pc",
          unitName: query,
          type: this.typee
        };
        setTimeout(() => {
          userApi.unitList(params).then(res => {
            this.loading = false;
            this.options = res.data;
          });
        }, 300);
      }
    },
    ishow() {
      if (
        this.userInfo.isSalesCustomers &&
        this.userInfo.isSalesCustomers == 1
      ) {
        this.$message.error("销售账户不能认证");
        return;
      }

      if (this.userInfo && !this.userInfo.mail) {
        // this.emilRules.emil[0].required = true;

        this.emilRules.elCode[0].required = true;
        this.emilRules.code[0].required = true;
        this.getImgCode();
        // this.userInfo.mail
        // this.$message.error("未绑定邮箱，请绑定邮箱后操作");
        // return;
      } else if (this.userInfo && this.userInfo.mail) {
        this.emilData.emil = this.userInfo.mail;
      }

      if (this.userInfo.name) {
        this.emilData.name = this.userInfo.name;
      }
      this.getNotAuthenticationTeamList();
      // this.emilVisible = true;
    },
    isRz() {
      this.isFindUnt = false;
      this.emilVisible = true;
    },
    getNotAuthenticationTeamList(type) {
      this.$loading.show();
      userApi.getNotAuthenticationTeamList().then(res => {
        if (res.code == 200) {
          console.log(res, "-res--");
          if (res.data && res.data.length > 0) {
            this.isFindUnt = true;
            this.tableData = res.data;
          } else {
            this.emilVisible = true;
          }
        }
        this.$loading.hide();
      });
    },
    subSetEmil() {
      this.$refs["elfrom"].validate(valid => {
        if (valid) {
          let params = {
            // id: this.customerInfoDTO.id, //客户Id
            channel: "pc",
            customerId: this.customerInfoDTO.customerId, // huiyuanid
            customerName: this.emilData.name,

            mail: this.emilData.emil,
            piId: this.pioptions.filter(res => {
              return res.id == this.emilData.pi;
            })[0].customerId,
            piName: this.pioptions.filter(res => {
              return res.id == this.emilData.pi;
            })[0].customerName,

            telePhone: this.customerInfoDTO.telephone,

            unitName: this.pioptions.filter(res => {
              return res.id == this.emilData.pi;
            })[0].unitName,

            myUnitId: this.pioptions.filter(res => {
              return res.id == this.emilData.pi;
            })[0].id,
            unitId: this.pioptions.filter(res => {
              return res.id == this.emilData.pi;
            })[0].unitId,

            id: 0
          };

          if (this.emilData.elCode) {
            params["mailCode"] = this.emilData.elCode;
          }

          console.log(params, "--params---");

          this.$loading.show();
          userApi.applicationTeam(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.data,
                type: "success"
              });
              this.emilData = {
                code: "",
                name: "",
                elCode: "",
                emil: "",
                codeImg: "",
                codeKey: "",
                uniName: "",
                pi: ""
              };
              this.emilVisible = false;
              this.$emit("getUser", "1");
              window.clearInterval(this.codeInterval3);
              this.codeInterval3 = null;
              this.sendMsgDisabled2 = false;
              this.codeTime2 = 59;
            } else {
              this.$message.error(res.msg);
            }
            this.$loading.hide();
          });
        }
      });
    },

    closeEmil() {
      this.emilData = {
        code: "",
        name: "",
        elCode: "",
        emil: "",
        codeImg: "",
        codeKey: "",
        uniName: "",
        PI: ""
      };
      this.namejson = "";
      this.pioptions = [];
      this.options = [];
      this.$refs["elfrom"].resetFields();
      console.log(this.emilData);
    },
    getEmilCode() {
      if (this.sendMsgDisabled2) {
        return;
      }
      let validateFieldList = [];
      this.$refs["elfrom"].validateField(
        ["emil", "code"],
        async (valid, obj) => {
          console.log(valid, "---");
          validateFieldList.push(valid);

          if (
            validateFieldList.length == 2 &&
            validateFieldList.every(item => item === "")
          ) {
            if (!valid) {
              // 获取验证码
              this.isloading = true;
              userApi
                .getEmilCode({
                  mail: this.emilData.emil,
                  verificationCode: this.emilData.code,
                  verificationCodeKey: this.emilData.codeKey,
                  type: 2
                })
                .then(res => {
                  if (res.code == 200) {
                    this.$message.success(res.data);
                    var _this = this;
                    _this.sendMsgDisabled2 = true;
                    this.codeInterval3 = window.setInterval(function() {
                      if (_this.codeTime2-- <= 0) {
                        _this.codeTime2 = 59;
                        _this.sendMsgDisabled2 = false;
                        window.clearInterval(this.codeInterval3);
                        this.codeInterval3 = null;
                      }
                    }, 1000);
                  } else {
                    this.$message.error(res.msg);
                    this.getImgCode();
                  }
                })
                .finally(e => {
                  this.isloading = false;
                });
            }
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.bottomtip {
  width: calc(100% - 100px);
  font-size: 14px;
  color: #abaaab;
  margin-left: 100px;
  margin-bottom: 20px;
  div {
    width: 100%;
  }
}
.dialog-title {
  text-align: left;
  font-size: 30px;
  color: #000;
  border-bottom: 4px solid #e5e5e5;
  width: calc(100% + 40px);
  margin-left: -20px;
  padding-bottom: 20px;
  padding-left: 60px;
  position: relative;

  span {
  }

  &::before {
    display: block;
    content: "";
    width: 65px;
    height: 4px;
    background-color: var(--ThemeColor);
    position: absolute;
    bottom: -4px;
    left: 60px;
  }
}

.dialog-form {
  padding: 0 60px;
  text-align: left;

  .get-verify {
    width: 100%;
    background-color: #3c4250;
    color: var(--textWhite);
  }

  .dilog-select {
    width: 100%;
  }

  .dialog-btns {
    text-align: center;

    .cancel,
    .confirm {
      font-size: 16px;
    }

    .confirm {
      color: var(--textWhite);
      background-color: var(--ThemeColor);
    }
  }
}

.verify-img {
  margin-left: 20px;
  width: 150px;
  height: 40px;
  // background-color: #3c4250;
  background-color: var(--ThemeColor);
  border-radius: 3px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }

  cursor: pointer;
}

.verify-img1 {
  margin-left: 20px;
  width: 150px;
  height: 40px;
  // background-color: #3c4250;
  background-color: var(--textGray);
  border-radius: 3px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }

  cursor: pointer;
}

.user-table {
  margin-top: 20px;

  /deep/.table-header {
    background-color: var(--ThemeColor) !important;
    color: var(--textWhite);
    font-size: 16px;
  }

  /deep/.table-header-cell {
    background-color: transparent;
    border: none;
  }

  /deep/.el-table__header-wrapper {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  /deep/.el-table__cell {
    border-color: #c5c5c5;
  }

  /deep/.el-table__body {
    // border-left: 1px solid #c5c5c5;
  }

  /deep/.el-table--striped
    .el-table__body
    tr.el-table__row--striped
    td.el-table__cell {
    background-color: #eff0f0;
  }

  /deep/.el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: #c5c5c5;
  }
}
/deep/.el-dialog__body {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/user/components/item.vue